<template>
  <div v-if="currentEmploye && currentObjectif">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Gestion des employés'"
          :description="'Aperçu d\'un objectif de l\'employé'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 d-flex justify-content-between">
                    <div>
                      Prénom et nom de l'employé :
                      {{
                        currentEmploye.prenom
                          ? currentEmploye.prenom + ' ' + currentEmploye.nom
                          : currentEmploye.nom
                      }}
                    </div>
                    <div>
                      <router-link
                        :to="{
                          name: 'rh_employe-show',
                          params: { id: currentEmploye.id },
                        }"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                      </router-link>
                    </div>
                  </td>
                  <td class="col-6 d-flex justify-content-between">
                    Matricule :
                    {{
                      currentEmploye.matricule
                        ? currentEmploye.matricule
                        : '###'
                    }}
                  </td>
                </tr>

                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6">
                    Email principal :
                    {{
                      currentEmploye.email_principal
                        ? currentEmploye.email_principal
                        : '###'
                    }}
                  </td>
                  <td class="col-6">
                    Téléphone :
                    {{
                      currentEmploye.telephone
                        ? currentEmploye.telephone
                        : '###'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between">
                    Nom de l'objectif :
                    {{ currentObjectif.nom }}
                  </td>
                </tr>

                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="getClassOfEO(currentObjectif.statut)"
                    ></i>

                    {{ getStatutEO(currentObjectif.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(prov).catch(() => {})"
        >
          Liste des objectifs
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="createObjectif"
        >
          <i class="fa fa-plus"></i>
          Ajout de nouvel objectif
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="editModalObjectif"
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-custom-primary"
          @click="showModalStatut"
        >
          Changer le statut
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_employe_objectif-show',
                params: {
                  employeId: currentEmploye.id,
                  prov: prov,
                  objectifId: currentObjectif.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Objectif concerné</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_objectif-document',
                params: {
                  employeId: currentEmploye.id,
                  prov: prov,
                  objectifId: currentObjectif.id,
                  documentUuid: currentObjectif.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_objectif-note',
                params: {
                  employeId: currentEmploye.id,
                  prov: prov,
                  objectifId: currentObjectif.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Notes</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view :key="$route.path" />
      </div>
    </div>
    <ModalStatut
      ref="modalStatut"
      :currentObjectif="currentObjectif"
      :statuts="objectifStatuts"
      @onChangeStatut="onChangeStatut"
    />
    <ModalObjectif
      ref="modalObjectif"
      :currentEmploye="currentEmploye"
      :prov="prov"
      :showUrl="showUrl"
      :objectifableUuid="currentObjectif.objectifable_uuid"
      :objectifableType="currentObjectif.objectifable_type"
      @successSavedObjectif="init"
    />
  </div>
</template>

<script>
import URL_O from '@/http/rh/employe-objectif';
import URL_E from '@/http/rh/employe';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import ModalStatut from '@/views/rh/shared/objectif/objectif/components/ModalStatut.vue';
import ModalObjectif from '@/views/rh/shared/objectif/objectif/components/ModalObjectif.vue';
export default {
  data() {
    return {
      reload: true,
      prov: this.$route.params.prov,
      title: 'Gestion des objectifs',
    };
  },
  computed: {
    ...mapGetters('employe', [
      'currentEmploye',
      'currentObjectif',
      'objectifStatuts',
    ]),
    showUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  components: {
    ModalStatut,
    ModalObjectif,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  watch: {
    reload: {
      immediate: true,
      handler(val) {
        if (val) this.init();
      },
    },
  },
  methods: {
    createObjectif() {
      this.$refs.modalObjectif.create();
    },
    editModalObjectif() {
      this.$refs.modalObjectif.edit(this.currentObjectif.id);
    },
    showModalStatut() {
      this.$refs.modalStatut.showModal();
    },
    onChangeStatut(objectif) {
      this.setCurrentObjectif(objectif);
      this.reload = true;

      /* this.$router
        .push({
          name: 'rh_employe_objectif-show',
          params: {
            employeId: this.currentEmploye.id,
            prov: this.prov,
            id: this.currentObjectif.id,
          },
        })
        .catch(() => {});*/
    },

    ...mapActions('employe', [
      'setCurrentEmploye',
      'setCurrentObjectif',
      'setEdit',
    ]),
    init() {
      this.setCurrentEmploye(null);
      this.setCurrentObjectif(null);
      this.setEdit(true);

      window.axios
        .all([
          window.axios.get(URL_E.EMPLOYE + '/' + this.$route.params.employeId),
          window.axios.get(
            URL_O.OBJECTIF + '/' + this.$route.params.objectifId
          ),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentEmploye(resp1.data.employe);
            this.setCurrentObjectif(resp2.data.objectif);
          })
        )
        .catch();
    },
  },
};
</script>
